import WRAP from "WRAP-JS";
import { COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";
import { CONTENTS_ID_POWER_PYLONS, CONTENTS_ID_POWER_PYLONS_SNK } from "../../../store/DisabledContentsState";
import { MAP_ID_POWER_PYLONS } from "../../../store/MapContentsState";
import { configPowerPylonCHUDENDh, configPowerPylonDh, configPowerPylonLayer, configPowerPylonTEPCODh } from "./config/ConfigPowerPylon";

class PowerPylon {
  static NAME = MAP_ID_POWER_PYLONS;
  static WHOLE_COUNTRY = `${PowerPylon.NAME}_WHOLE_COUNTRY`;
  static TEPCO = `${PowerPylon.NAME}_TEPCO`;
  static CHUDEN = `${PowerPylon.NAME}_CHUDEN`;
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [PowerPylon.WHOLE_COUNTRY]: true
  };
  static CONTENTS_VISIBLE_STATE_DEFAULT_SNK = {
    [PowerPylon.TEPCO]: true,
    [PowerPylon.CHUDEN]: true
  };

  defaultState;
  contentsVisibleState;

  dhPowerPylon;
  layerPowerPylon;
  ready = false;
  contentsType;
  layers = {
    [CONTENTS_ID_POWER_PYLONS]: [
      {name: PowerPylon.WHOLE_COUNTRY}
    ],
    [CONTENTS_ID_POWER_PYLONS_SNK]: [
      {name: PowerPylon.TEPCO},
      {name: PowerPylon.CHUDEN}
    ]
  }
  dhs = {
    [CONTENTS_ID_POWER_PYLONS]: [
      {name: PowerPylon.WHOLE_COUNTRY, conf: configPowerPylonDh}
    ],
    [CONTENTS_ID_POWER_PYLONS_SNK]: [
      {name: PowerPylon.TEPCO, conf: configPowerPylonTEPCODh},
      {name: PowerPylon.CHUDEN, conf: configPowerPylonCHUDENDh}
    ]
  }
  isDark;
  prefixes = {}
  contentsDispatcher;
  errorMessageInfo = {};
  visible;

  constructor(disabled, isDark) {
    this.isDark = isDark;
    if (!disabled[CONTENTS_ID_POWER_PYLONS_SNK]) {
      this.contentsType = CONTENTS_ID_POWER_PYLONS_SNK;
      this.defaultState = PowerPylon.CONTENTS_VISIBLE_STATE_DEFAULT_SNK;
      this.contentsVisibleState = {...PowerPylon.CONTENTS_VISIBLE_STATE_DEFAULT_SNK}
    } else {
      this.contentsType = CONTENTS_ID_POWER_PYLONS;
      this.defaultState = PowerPylon.CONTENTS_VISIBLE_STATE_DEFAULT;
      this.contentsVisibleState = {...PowerPylon.CONTENTS_VISIBLE_STATE_DEFAULT};
    }

    this.layers[this.contentsType].forEach(l => {
      l.layer = new WRAP.Geo.Layer(l.name);
      l.layer.setVisible(false);
      l.layer.disableInteraction(true);
    });
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  async _initData(name) {
    return new Promise((resolve, reject) => {
      const dh = this.dhs[this.contentsType].find(dh => dh.name === name);
      dh.dh = new WRAP.Data(dh.conf);
      dh.dh.updated('index', ref => {
        if (this.errorMessageInfo[name]) {
          this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo[name]});
          this.errorMessageInfo[name] = null;
        }
        this.prefixes[name] = ref[0].Prefix;
        resolve(dh.dh);
      }, () => {
        this.errorMessageInfo[name] = this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: dh.dh.conf.apiName,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
    });
  }

  _initLayer(name, dh) {
    const layer = this.layers[this.contentsType].find(layer => layer.name === name);
    layer.layer.configure(dh, configPowerPylonLayer);
    layer.layer.set({prefix: this.prefixes[name]});
  }

  async drawLayer(visible) {
    this.visible = visible;
    await this.setVisible(visible);
  }

  getLayer() {
    return this.layers[this.contentsType].map(l => l.layer);
  }

  async setVisible(visible) {
    if (visible) {
      for await (const key of Object.keys(this.contentsVisibleState)) {
        await this._setContentsVisible(key);
      }
    } else {
      this.layers[this.contentsType].forEach(l => {
        l.layer.hide();
      });
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...this.defaultState};
  }

  async _setContentsVisible(name) {
    const layer = this.layers[this.contentsType].find(l => l.name === name);
    if (this.contentsVisibleState[name] && this.visible) {
      if (!this.prefixes[name]) {
        try {
          const dh = await this._initData(name);
          if (dh) {
            this._initLayer(name, dh);
            layer.layer.show();
          }
        } catch {
          console.log('powerPylon load error');
        }
      } else {
        layer.layer.show();
      }
    } else {
      layer.layer.hide();
    }
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
    this._setContentsVisible(name, visible);
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? 'dark' : 'default';
    this.layers[this.contentsType].forEach(l => {
      l.layer.setStyle(style);
    });
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default PowerPylon;
